import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react';
import UIWidth from '../UIWidth';
export default function ImageBanner({
  title = null,
  text = null,
  image,
  imageAlt = "",
  accentColor = 'brand.10',
  imageFirst = null,
  children = null,
  py = '2rem',
}) {
  return (
    <Box width="100%" background={accentColor} py={py}>
      <UIWidth>
        <Flex
          direction={['column', '', imageFirst ? 'row-reverse' : 'row']}
          justify="center"
          align="center"
          gap="1.25rem"
        >
          <Flex
            direction="column"
            align="center"
            gap={title ? ['1rem', '2rem'] : null}
            flexBasis={{ sm: '50%' }}
          >
            {title && (
              <Heading as="h2" variant="h2" textAlign="center" color="inherit">
                {title}
              </Heading>
            )}
            {text &&
              <Text fontSize={['1rem', '', '1.25rem']} textAlign="center">
                {text}
              </Text>
            }
            {children && children}
          </Flex>
          <Box
            height={['15rem', '20rem', '22.5rem']}
            width={['100%', '', '50%']}
            flexBasis={{ md: '50%' }}
          >
            <Image
              src={image}
              alt={imageAlt}
              height="100%"
              width="100%"
              objectFit="cover"
            />
          </Box>
        </Flex>
      </UIWidth>
    </Box>
  );
}
